import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-up-black",
  "use": "icon-arrow-up-black-usage",
  "viewBox": "0 0 12.56 7",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12.56 7\" id=\"icon-arrow-up-black\"><title>icon-arrow-up-black</title><path d=\"M6.33,2.81,1.86,6A13.7,13.7,0,0,0,.46,7L0,6.19,2.74,3.48C3.9,2.32,5,1.16,6.12,0h.42l3.73,3.87c.81.81,1.55,1.62,2.29,2.32L12,7Z\" style=\"fill:#222\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol